import React from "react";

import TradeVerticalPage from "../../../components/admin/Dashboard/trade/TradeVerticalPage";
import { TRADE_VERTICALS } from "../../../constants/tradeVerticals";

const TradeInformation = () => <TradeVerticalPage config={TRADE_VERTICALS.information} />;

export default TradeInformation;
